import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StyledNavDropdown from "./StyledNavDropdown";
import { NavDropdown } from "react-bootstrap";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

const LoggedOutDropdown = () => {
  const location = useLocation();

  return (
    <StyledNavDropdown
      title={
        <span className="text-white">
          <FontAwesomeIcon icon={faBars} />
        </span>
      }
      align="end"
    >
      <NavDropdown.Item href="/boundaries">Boundaries</NavDropdown.Item>
      <NavDropdown.Item href="/datasets">Datasets</NavDropdown.Item>
      <NavDropdown.Item
        href="https://support.basemap.co.uk/support/login"
        target="_blank"
      >
        Support
      </NavDropdown.Item>

      {location.pathname.toLowerCase() !== "/" && (
        <>
          <NavDropdown.Divider />
          <NavDropdown.Item href="/login">Login</NavDropdown.Item>
        </>
      )}
    </StyledNavDropdown>
  );
};

export default LoggedOutDropdown;
